type Props = {
  placementId: string;
  containerId: string;
  adIndex: number;
  categories?: string | undefined;
  initialLayoutType?: string | undefined;
  webComponentName?: string | undefined;
  slotId: string;
};

export function injectSlotInWebComponent(props: Props) {
  if (typeof window === 'undefined') return;

  const { webComponentName, placementId } = props;

  if (!webComponentName) return;
  if (!placementId) return;

  const webComponent = document.querySelector(webComponentName);

  if (!webComponent) return;

  const advtComponent = createAdvtWebComponent(props);
  webComponent.appendChild(advtComponent);
}

function createAdvtWebComponent({
  placementId,
  containerId,
  adIndex,
  categories,
  initialLayoutType,
  slotId
}: Props) {
  const advtComponent = document.createElement('advt-component');

  const attributes = [
    ['placementId', placementId],
    ['adIndex', adIndex],
    ['containerId', containerId],
    ['categories', categories],
    ['initialLayoutType', initialLayoutType || 'grid'],
    ['slot', slotId],
    ['id', slotId]
  ] as const;

  for (const [key, value] of attributes) {
    if (typeof value === 'undefined') continue;

    advtComponent.setAttribute(
      key,
      typeof value === 'number' ? `${value}` : value
    );
  }

  return advtComponent;
}
